<ng-container
  *ngIf="activityData?.api"
>
  <mng-services-executions [config]="config"></mng-services-executions>
</ng-container>
